import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { CheckMobile } from '../../../AppSystem/Helpers/CheckMobile';
import { t } from 'i18next';

// Counter to track how many panels are open simultaneously
let openPanelCount = 0;

export function SlidePanel({ isOpen, onClose, title, children, zIndexOffset = 0, variant = "side", onEditClick, closeIcon = "x", onBack = null, closeOnOutsideClick = true }) {
  const isMobile = CheckMobile(998);
  const panelRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [animating, setAnimating] = useState(false);
  const handleBackClick = onBack ?? onClose;

  // Capture the stack level at mount time so it never changes while open
  const stackLevel = useRef(0);

  // Base z-index — each nested panel gets +20 so it renders on top
  const baseZ = 1035 + zIndexOffset + stackLevel.current * 20;

  // Mount → animate in
  useEffect(() => {
    if (isOpen) {
      // Assign this panel's level BEFORE incrementing so first panel = 0, second = 1, etc.
      stackLevel.current = openPanelCount;
      openPanelCount++;
      setVisible(true);
      const timer = setTimeout(() => setAnimating(true), 16);
      window.dispatchEvent(new CustomEvent('slidePanelChange', { detail: { open: true } }));
      return () => clearTimeout(timer);
    } else {
      setAnimating(false);
      const timer = setTimeout(() => {
        setVisible(false);
        openPanelCount = Math.max(0, openPanelCount - 1);
        // Reset level so it gets reassigned next time this panel opens
        stackLevel.current = 0;
        if (openPanelCount === 0) {
          window.dispatchEvent(new CustomEvent('slidePanelChange', { detail: { open: false } }));
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // Outside click — only close if click is outside ALL slide panels
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!isOpen) return;
      if (!closeOnOutsideClick) return;
      if (!panelRef.current) return;
      if (panelRef.current.contains(e.target)) return;

      if (e.target.closest('.modal') || e.target.classList.contains('modal')) return;
      if (e.target.closest('.modal-dialog')) return;
      if (e.target.classList.contains('modal-backdrop') || e.target.closest('.modal-backdrop')) return;

      const allPanels = document.querySelectorAll(
        '.slidePanelMobile, .slidePanelDesktop, .slidePanelCenter'
      );
      for (const panel of allPanels) {
        if (panel !== panelRef.current && panel.contains(e.target)) return;
      }

      onClose();
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [isOpen, onClose, closeOnOutsideClick]);

  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;
    const scrollY = window.scrollY;

    const previousStyles = {
      bodyOverflow: body.style.overflow,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyLeft: body.style.left,
      bodyRight: body.style.right,
      bodyWidth: body.style.width,
      bodyOverscrollBehavior: body.style.overscrollBehavior,
      htmlOverflow: html.style.overflow,
      htmlOverscrollBehavior: html.style.overscrollBehavior,
    };

    if (isOpen) {
      body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';
      body.style.overscrollBehavior = 'none';
      html.style.overscrollBehavior = 'none';

      if (isMobile) {
        body.style.position = 'fixed';
        body.style.top = `-${scrollY}px`;
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
      }
    }

    return () => {
      body.style.overflow = previousStyles.bodyOverflow;
      body.style.position = previousStyles.bodyPosition;
      body.style.top = previousStyles.bodyTop;
      body.style.left = previousStyles.bodyLeft;
      body.style.right = previousStyles.bodyRight;
      body.style.width = previousStyles.bodyWidth;
      body.style.overscrollBehavior = previousStyles.bodyOverscrollBehavior;
      html.style.overflow = previousStyles.htmlOverflow;
      html.style.overscrollBehavior = previousStyles.htmlOverscrollBehavior;

      if (isOpen && isMobile) {
        window.scrollTo(0, scrollY);
      }
    };
  }, [isOpen, isMobile]);

  // Outside click — only close if click is outside ALL slide panels
  // useEffect(() => {
  //   const handleOutsideClick = (e) => {
  //     if (!isOpen) return;
  //     if (!panelRef.current) return;
  //     if (panelRef.current.contains(e.target)) return;

  //     if (e.target.closest('.modal') || e.target.classList.contains('modal')) return;
  //     if (e.target.closest('.modal-dialog')) return;
  //     if (e.target.classList.contains('modal-backdrop') || e.target.closest('.modal-backdrop')) return;

  //     const allPanels = document.querySelectorAll(
  //       '.slidePanelMobile, .slidePanelDesktop, .slidePanelCenter'
  //     );
  //     for (const panel of allPanels) {
  //       if (panel !== panelRef.current && panel.contains(e.target)) return;
  //     }

  //     onClose();
  //   };

  //   document.addEventListener('mousedown', handleOutsideClick);
  //   return () => document.removeEventListener('mousedown', handleOutsideClick);
  // }, [isOpen, onClose]);

  // Outside click — only close if click is outside ALL slide panels
  // useEffect(() => {
  //   const handleOutsideClick = (e) => {
  //     if (!isOpen) return;
  //     if (!panelRef.current) return;
  //     if (panelRef.current.contains(e.target)) return;

  //     if (e.target.closest('.modal') || e.target.classList.contains('modal')) return;
  //     if (e.target.closest('.modal-dialog')) return;
  //     if (e.target.classList.contains('modal-backdrop') || e.target.closest('.modal-backdrop')) return;

  //     const allPanels = document.querySelectorAll(
  //       '.slidePanelMobile, .slidePanelDesktop, .slidePanelCenter'
  //     );
  //     for (const panel of allPanels) {
  //       if (panel !== panelRef.current && panel.contains(e.target)) return;
  //     }

  //     onClose();
  //   };

  //   document.addEventListener('mousedown', handleOutsideClick);
  //   return () => document.removeEventListener('mousedown', handleOutsideClick);
  // }, [isOpen, onClose]);

  // Outside click — only close if click is outside ALL slide panels
  // useEffect(() => {
  //   const handleOutsideClick = (e) => {
  //     if (!isOpen) return;
  //     if (!panelRef.current) return;
  //     if (panelRef.current.contains(e.target)) return;

  //     if (e.target.closest('.modal') || e.target.classList.contains('modal')) return;
  //     if (e.target.closest('.modal-dialog')) return;
  //     if (e.target.classList.contains('modal-backdrop') || e.target.closest('.modal-backdrop')) return;

  //     const allPanels = document.querySelectorAll(
  //       '.slidePanelMobile, .slidePanelDesktop, .slidePanelCenter'
  //     );
  //     for (const panel of allPanels) {
  //       if (panel !== panelRef.current && panel.contains(e.target)) return;
  //     }

  //     onClose();
  //   };

  //   document.addEventListener('mousedown', handleOutsideClick);
  //   return () => document.removeEventListener('mousedown', handleOutsideClick);
  // }, [isOpen, onClose]);

  if (!visible) return null;

  // Recalculate here so the rendered z-index reflects the captured stackLevel
  const z = 1035 + zIndexOffset + stackLevel.current * 20;

  if (isMobile) {
    return createPortal(
      <>
        <div
          onClick={() => {
            if (closeOnOutsideClick) onClose();
          }}
          className="slidePanelOverlayMobile"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            //bottom: 64,
            bottom: 0,
            background: 'rgba(0,0,0,0.25)',
            zIndex: z,
            opacity: animating ? 1 : 0,
            transition: 'opacity 0.3s ease',
          }}
        />
        <div
          ref={panelRef}
          className="slidePanelMobile"
          style={{
            transform: animating ? 'translateY(0)' : 'translateY(100%)',
            zIndex: z + 1,
          }}
        >
          <div className="slidePanelHandle" />
          <div className="slidePanelHeader">
            {/* Back arrow — same action as close */}
            <button onClick={handleBackClick} className="slidePanelNavBtn" aria-label="Back">
              {closeIcon === "arrow"
                ? <i className="bx bx-arrow-back" />
                : <i className="bx bx-x" style={{ fontSize: 20 }} />
              }
            </button>

            {/* Title centered */}
            <span className="slidePanelTitle">{title}</span>

            {/* Help button — no action yet */}
            {/* <button className="slidePanelNavBtn slidePanelNavBtnHelp" aria-label="Help" onClick={() => {}}>
              ?
            </button> */}
            {onEditClick && (
              <button className={'hp-edit-toggle'} onClick={onEditClick} aria-label="Edit">
                  <i className="bx bxs-pencil" />
              </button>
            )}
          </div>
          <div className="slidePanelMobileContent">
            {children}
          </div>
        </div>
      </>,
      document.body
    );
  }

  // Desktop
  if (variant === "center") {
    return createPortal(
      <>
        <div
          //onClick={onClose}
          className="slidePanelOverlayDesktop"
          style={{
            opacity: animating ? 1 : 0,
            zIndex: z,
          }}
        />
        <div
          ref={panelRef}
          className="slidePanelCenter"
          style={{
            transform: animating
              ? 'translateX(-50%) translateY(0)'
              : 'translateX(-50%) translateY(100%)',
            zIndex: z + 1,
          }}
        >
          <div className="slidePanelHeaderDesktop">
            <button onClick={handleBackClick} className="slidePanelNavBtn" aria-label="Back">
              {closeIcon === "arrow"
                ? <i className="bx bx-arrow-back" />
                : <i className="bx bx-x" style={{ fontSize: 20 }} />
              }
            </button>
            <span className="slidePanelTitleDesktop">{title}</span>
            {/* <button className="slidePanelNavBtn slidePanelNavBtnHelp" aria-label="Help" onClick={() => {}}>
              ?
            </button> */}
            {onEditClick && (
              <button className={'hp-edit-toggle'} onClick={onEditClick} aria-label="Edit">
                  <i className="bx bxs-pencil" />
              </button>
            )}
          </div>
          <div className="slidePanelDesktopContent">
            {children}
          </div>
        </div>
      </>,
      document.body
    );
  }

  return createPortal(
    <>
      <div
        // onClick={onClose}
        className="slidePanelOverlayDesktop"
        style={{
          opacity: animating ? 1 : 0,
          zIndex: z,
        }}
      />
      <div
        ref={panelRef}
        className="slidePanelDesktop"
        style={{
          transform: animating ? 'translateX(0)' : 'translateX(100%)',
          zIndex: z + 1,
        }}
      >
        <div className="slidePanelHeaderDesktop">
          {/* Back arrow — same action as close */}
          <button onClick={handleBackClick} className="slidePanelNavBtn" aria-label="Back">
            {closeIcon === "arrow"
              ? <i className="bx bx-arrow-back" />
              : <i className="bx bx-x" style={{ fontSize: 20 }} />
            }
          </button>

          {/* Title centered */}
          <span className="slidePanelTitleDesktop">{title}</span>

          {/* Help button — no action yet */}
          {/* <button className="slidePanelNavBtn slidePanelNavBtnHelp" aria-label="Help" onClick={() => {}}>
            ?
          </button> */}
          {onEditClick && (
              <button className={'hp-edit-toggle'} onClick={onEditClick} aria-label="Edit">
                  <i className="bx bxs-pencil" />
              </button>
          )}
        </div>
        <div className="slidePanelDesktopContent">
          {children}
        </div>
      </div>
    </>,
    document.body
  );
}